import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import { SensorEvent, SensorType } from '../../types/sensor-type';
import { GzFormFieldWebComponent } from '../../../../ui/gzForm/formField';
import { GzCheckboxWebComponent } from '../../../../ui/gzCheckbox';
import _ from 'lodash';
import { SensorEnabledStatus } from '../../../common/types';

export abstract class BaseSensorWebView extends BaseWebComponentView {
  public formGroup: FormGroup;
  public baseDom: {
    $wrapper: HTMLElement;
    $sensorSelectWrapper: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;
  };

  protected abstract createFormGroup();

  protected setViewData(viewData) {
    if ('' === _.get(viewData, ['response', '_id'], '')) {
      //first init
      this.setEnabledAllFields(true);

      return;
    }

    const enableStatus = _.get(viewData, ['response', 'enabledStatus'], true);
    const enabled = enableStatus === SensorEnabledStatus.ENABLED;
    this.baseDom.$sensorSelectWrapper.Input.checked = enabled;
    if (!enabled) {
      this.setEnableOnDataFields(enabled);
    }
  }

  getDomElements(): void {
    this.baseDom = {
      $wrapper: this.shadow.querySelector('.form-wrapper'),
      $sensorSelectWrapper: this.shadow.querySelector('.sensor-select-wrapper'),
    };
  }

  getTranslations(): void {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    this.translations = this.stringsTranslator.getSensorsIntegrationsStrings();
  }

  setBaseTranslatedStrings(sensorType: SensorType): void {
    this.dom.$sensorSelectWrapper.Input.label =
      typeof this.translations.sensorNames[sensorType] !== 'undefined'
        ? this.translations.sensorNames[sensorType]
        : this.translations.unknownSensorTypeLabel;
  }

  buildView(viewData): void {
    this.buildSuccessView(viewData);
  }

  public buildSuccessView(viewData): void {
    this.setTranslatedStrings();
    this.createFormGroup();
    this.setViewData(viewData);
    const inEdit = _.get(viewData, ['response', '_id'], false);
    this.dom.$wrapper.dispatchEvent(
      new CustomEvent(SensorEvent.init, {
        detail: {
          inEdit: inEdit,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  public setEnableOnDataFields(isEnabled: boolean): void {
    if (isEnabled) {
      this.formGroup.setChildrenAttribute('disabled', '');
    } else {
      this.formGroup.setChildrenAttribute('disabled', 'disable');
    }
  }

  public setEnabledAllFields(isEnabled: boolean): void {
    this.dom.$sensorSelectWrapper.disabled = !isEnabled;
    this.setEnableOnDataFields(isEnabled);
  }

  public resetData(): void {
    this.dom.$sensorSelectWrapper.Input.checked = true;
    this.dom.$sensorSelectWrapper.disabled = true;
  }
}
